import type { IconProps } from "./Icon";
import { Icon } from "./Icon";

export const WiFiIcon = ({ color = "#000000", width = 14, height = 10, ...props }: IconProps) => (
  <Icon {...props} width={width} height={height}>
    <g opacity="0.9">
      <path
        d="M13.3282 2.87894C11.7229 1.26255 9.4985 0.261719 7.04045 0.261719C4.57494 0.261719 2.34465 1.26857 0.738281 2.89354L2.13071 4.28604C3.38071 3.01741 5.11881 2.23095 7.04045 2.23095C8.95475 2.23095 10.6867 3.01137 11.9356 4.27141L13.3282 2.87894Z"
        fill={color}
      />
      <path
        d="M11.0654 5.14169C10.0392 4.10437 8.61484 3.46172 7.04045 3.46172C5.45859 3.46172 4.02831 4.11043 3.00102 5.15634L4.39357 6.5489C5.06436 5.85932 6.00246 5.43095 7.04045 5.43095C8.07109 5.43095 9.00307 5.85322 9.6729 6.5342L11.0654 5.14169Z"
        fill={color}
      />
      <path
        d="M8.80258 7.40452C8.35559 6.94626 7.73119 6.66172 7.04045 6.66172C6.34225 6.66172 5.71196 6.95239 5.264 7.41931L7.0259 9.18121L8.80258 7.40452Z"
        fill={color}
      />
    </g>
  </Icon>
);

export default WiFiIcon;
